import { StandardEvents } from '@shopify/events';

/**
 * <hd-buy-price> — mantém o preço HD (snippet hd-price) sincronizado com a
 * variante selecionada. Espelha o comportamento do <product-price> nativo do
 * Horizon: ouve o StandardEvents.productSelect disparado pela variant-picker e,
 * quando a seção re-renderizada chega no detail.html, troca o conteúdo interno
 * pelo preço da nova variante (já renderizado server-side pelo hd-price).
 */
class HdBuyPrice extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && this.dataset.productId && detail.productId !== this.dataset.productId) return;
        const fresh = detail.html.querySelector(`hd-buy-price[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[hd-buy-price] promise rejected:', error);
      });
  };
}

if (!customElements.get('hd-buy-price')) {
  customElements.define('hd-buy-price', HdBuyPrice);
}
